<template>
  <div class="c-grid-view">
    <GridControls :gridColumns="gridColumns" />
    <template v-for="item in computedNotes">
      <component
        v-if="item.type === 'header'"
        :is="'GridHeader'"
        :headerKey="item.domain"
        :site="item.site"
        :href="item.href"
        :key="item.domain"
      >
      </component>
      <component
        v-if="item.type === 'note'"
        :is="'GridItem'"
        :gridColumns="gridColumns"
        :headerKey="item.item.domain"
        :note="item.item"
        :showBucket="false"
        :key="item.domain"
        @shiftSelect="onSearchSelect(note.item, 'shift')"
        @ctrlSelect="onSearchSelect(note.item, 'ctrl')"
        @onPreview="setCurrentNote(note.item)"
      >
      </component>
    </template>
  </div>
</template>

<script>
import GridControls from "@/components/dashboard/grid-controls";
import GridHeader from "@/components/dashboard/grid-header";
import GridItem from "@/components/dashboard/grid-item";

export default {
  components: {
    GridControls,
    GridHeader,
    GridItem,
  },
  props: ["computedNotes"],
  computed: {
    gridColumns: function () {
      return this.$store.getters["dashboard/gridColumns"] || [];
    },
  },
  methods: {
    setCurrentNote: function (note) {
      //this.currentNote = note;
    },
    onSearchSelect: function (note, mode) {
      if (this.computedSearch.length < 1) {
        return;
      }

      mode = mode || "shift";
      let selectedNotes = this.selectedNotes;
      let results = [];
      let mutation = "ACTIVATE_SELECTION";
      if (mode === "ctrl") {
        mutation = "DEACTIVATE_SELECTION";
      }
      var notes = this.computedSearch.map((item) => {
        return item.item;
      });
      results = this.setShiftSelect(notes, note, selectedNotes, mode);

      for (var i = 0; i < results.length; i++) {
        this.$store.commit(mutation, results[i]);
      }
    },
    onSiteSelect: function (note, mode) {
      mode = mode || "shift";
      let selectedNotes = this.selectedNotes;
      let results = [];
      let temp = [];
      let mutation = "ACTIVATE_SELECTION";
      if (mode === "ctrl") {
        mutation = "DEACTIVATE_SELECTION";
      }
      let notes = this.computedNoteList;
      let trigger = false;
      let reverse = false;
      for (var i = 0; i < notes.length; i++) {
        if (selectedNotes.includes(notes[i].id)) {
          reverse = true;
          trigger = true;
        }
        if (trigger) {
          results.push(notes[i]);
        }
        if (note.id === notes[i].id) {
          reverse = false;
          trigger = false;
        }
      }
      if (reverse) {
        notes = notes.reverse();
        results = [];
        for (var i = 0; i < notes.length; i++) {
          if (selectedNotes.includes(notes[i].id)) {
            trigger = true;
          }
          if (trigger) {
            results.push(notes[i]);
          }
          if (note.id === notes[i].id) {
            trigger = false;
          }
        }
      }
      for (var i = 0; i < results.length; i++) {
        this.$store.commit(mutation, results[i]);
      }
    },
    setShiftSelect: function (arr, note, selectedNotes, mode) {
      mode = mode || "shift";
      selectedNotes = selectedNotes || this.selectedNotes;
      arr = JSON.parse(JSON.stringify(arr));

      var selectedNotes = this.selectedNotes;

      var id = note.id;
      var toggle = false;
      var results = [];
      arr = arr.reverse();
      if (mode === "shift") {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].id === id) {
            results.push(arr[i]);
            toggle = true;
          }
          if (toggle) {
            results.push(arr[i]);
          }
          if (selectedNotes.includes(arr[i].id)) {
            results.push(arr[i]);
            toggle = false;
            break;
          }
        }
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (selectedNotes.includes(arr[i].id)) {
            results.push(arr[i]);
            toggle = true;
          }

          if (toggle) {
            results.push(arr[i]);
          }
          if (arr[i].id === id) {
            results.push(arr[i]);
            toggle = false;
            break;
          }
        }
      }
      return results;
    },
    getSibling: function (el, selector, mode) {
      mode = mode || "next";
      let sibling = el.nextElementSibling;
      if (mode === "prev") {
        sibling = el.previousElementSibling;
      }
      while (sibling) {
        if (sibling.matches(selector)) {
          return sibling;
        }
        if (mode === "next") {
          sibling = sibling.nextElementSibling;
        } else {
          sibling = sibling.previousElementSibling;
        }
      }
    },
    setListFocus: function (dir) {
      dir = dir || "down";
      let el = document.activeElement;
      let sibling = false;
      if (el.classList.contains("c-grid-item")) {
        if (dir === "down") {
          sibling = this.getSibling(el, ".c-grid-item");
        } else {
          sibling = this.getSibling(el, ".c-grid-item", "prev");
        }
        if (sibling) {
          sibling.focus();
        }
      } else {
        if (dir === "down") {
          document.querySelectorAll(".c-grid-item")[0].focus();
        } else {
          let temp = document.querySelectorAll(".c-grid-item");
          temp[temp.length - 1].focus();
        }
      }
    },
    hotkeyHandler: function (e) {
      if (this.listView === "reader") {
        return;
      }
      if (e.key === "ArrowDown") {
        this.setListFocus();
      }
      if (e.key === "ArrowUp") {
        this.setListFocus("up");
      }
      if (e.key === "ArrowRight") {
        // set focus to the right panel
      }
      if (e.key === "ArrowLeft") {
        // set focus to the left panel
      }
      // if(e.key === 'ArrowRight' && e.ctrlKey === true) {
      // 	this.horizontalScroll('right');
      // }
      // if(e.key === 'ArrowLeft' && e.ctrlKey === true) {
      // 	this.horizontalScroll('left');
      // }
    },
    setupHotkeys: function () {
      hotkeys("*", "selection", this.hotkeyHandler);
      hotkeys.setScope("grid");
    },
    removeHotkeys: function () {
      hotkeys.deleteScope("grid");
    },
  },
  mounted: function () {
    this.setupHotkeys();
  },
  beforeDestroy: function () {
    this.removeHotkeys();
  },
};
</script>

<style lang="scss">
.c-grid-view {
  overflow-x: auto;

  @include scrollBars();
}
</style>